import React, { useState } from "react";
import "./RequestChange.scss";
import { Modal, Row, Col } from "react-bootstrap";
import { ButtonV1 } from "lib";
import { useDispatch, useSelector } from "react-redux";
import { postRequestedDocs } from "api/dashboardDetail";
// import { useParams } from "react-router-dom";
// import Toast from "components/ToastComponent";
import DashBoardMultiDropdown from "lib/MultiDropdown/DashBoardMultiDropdown";
import { requestChangeForPaymentThroughId } from "api/payment";
import {DropdownV1} from "../../lib"

const RequestChangeModal = (props) => {
  const urlParams = useSelector((state) => state?.urlEncryption?.urlParams);
  // const urlParams = useParams();

  const {
    show,
    onHide,
    options,
    blockSection,
    blockGroup,
    blockName,
    requestedFlow,
    customButton,
    paymentBlock,
    block_data,
    assignee_required,
    request_change_option,
    role,
    user,
    notification
  } = props;
  
  const [dropDownValues, setDropDownValues] = useState([]);
  const [comment, setComment] = useState("");
  const [dropdownV1Value, setDropdownV1Value] = useState({})
  const [selectedUser,setSelectedUser] = useState({})
  const dispatch = useDispatch();
  // const requestedDocs = useSelector(
  //   (state) => state?.requestedDocsReducer?.requestedDocs
  // );
  // const loading = useSelector((state) => state?.requestedDocsReducer?.loading);
  // const error = useSelector((state) => state?.requestedDocsReducer?.error);
  // const successFullyRequestedDocs = useSelector(
  //   (state) => state?.requestedDocsReducer?.success
  // );
  const organisationInfo = useSelector((state) => state?.loggedInUserInfo?.userAuthInfo?.organisationInfo)

  const currentSubWorkFlowId = useSelector(
    (state) => state?.dashboardDetailReducer?.currentSubWorkFlowId
  );
  const userSubworkFlowInfo = useSelector(
    (state) => state?.dashboardDetailReducer?.userSubworkFlowInfo
  );

  const workFlowCreatedBy = useSelector((state)=>state?.dashboardDetailReducer.workFlowInfo.created_by)

  const dashboardDetailData = useSelector(
    (state) =>
      state?.dashboardDetailReducer?.dashboardDetailData?.subworkFlowInfo
  );

  const organisation_id = useSelector(
    (state) => state?.loggedInUserInfo?.userAuthInfo
  )?.organisationInfo?._id;

  const profileData = useSelector(
    (state) => state?.loggedInUserInfo?.userAuthInfo
  )?.profileInfo;

  const payment_details = useSelector((state) => state.paymentReducer?.payment_details);
  const all_users = useSelector((state)=> state.dashboardReducer?.allUsers)

  const handleSend = () => {
    const obj = {};
    let listOfDocs =
      dropDownValues?.length &&
      dropDownValues.map((item) => ({
        name: item.value,
        label: item.label,
      }));
    let depentFieldsArray = [];
    dropDownValues?.length &&
      dropDownValues.map((item) => {
        if (item.dependentfield) {
          item.dependentfield.map((item) => {
            depentFieldsArray.push(item);
          });
        }
      });
    if (paymentBlock) {
      const req_body = {
        transaction_id: block_data?.transaction_id,
        userId: block_data?.userId || block_data?.created_by,
        payment_id: payment_details?._id,
        internalUserName: profileData.first_name + " " + profileData.last_name,
        requestChange: listOfDocs,
        comment: comment,
        active_section: 1,
        active_group:
          block_data.payment_type?.toLowerCase() === "partial" &&
          block_data?.payment_mode?.toLowerCase() === "offline"
            ? 2
            : 1,
        dependentFields: depentFieldsArray,
        blockName: blockName,
        createdBy: profileData?.userId,
        requestedFlow: "update",
      };

      dispatch(requestChangeForPaymentThroughId(req_body));
      //payment request change api
    } else {
      const body = {
        listOfDocs,
        comment,
        email: assignee_required == 'true' ? selectedUser?.email_id  : dashboardDetailData?.email || '',
        profileData: selectedUser.profileData||[],
        request_change_option: request_change_option || 'user',
        createdBy: profileData?.userId,
        name:  assignee_required == 'true' ? selectedUser?.first_name + ' ' +selectedUser?.last_name  : dashboardDetailData?.full_name||"",
        requestedFlow: requestedFlow ? requestedFlow : "update",
        active_section: blockSection,
        active_group: blockGroup,
        dependentFields: depentFieldsArray,
        blockName: blockName,
        internalUserName: profileData?.first_name + " " + profileData?.last_name || "",
        // has_link_expiry: organisationInfo?.has_link_expiry,
        hours: organisationInfo?.setting?.link_expiry_duration_in_hours,
        customButton: customButton,
        assignee_required:assignee_required,
      };
      obj.body = body;

      const params = {
        primaryWorkflowId: urlParams?.primaryWorkflowId,
        userId: userSubworkFlowInfo.user_id || userSubworkFlowInfo.applicant_id,
        subWfId: currentSubWorkFlowId,
        organisation_id: organisation_id,
      };
      obj.params = params;
      // validation before sending request to api as these are required params
      if (obj && params?.primaryWorkflowId && params?.userId && params?.subWfId && organisation_id) {
        dispatch(postRequestedDocs(obj));
      }
    }
    onHide();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };


  const dropdownv1OnChange=(e)=>{
    const { name, value } = e.target;
    let obj ={}
    if (request_change_option === "role") {
      let userList;
      if(user?.includes('creator')){
          userList= all_users.filter(
          (obj) => (obj?.role === value&&obj?._id===workFlowCreatedBy)
        )
      }else{
        userList= all_users.filter(
        (obj) => obj?.role === value
      );
      }
     
      let profileDetails = userList.map(({ _id, profile, email_id,mobile_number }) => ({ _id, profile, email_id ,mobile_number}));
      obj = {
        profileData: profileDetails,
      };
     
    } else {
      let selected_user = all_users.filter((e) => {
        return e._id == value;
      });
      if (selected_user?.length) {
        selected_user = selected_user[0];
        obj = {
          ...selected_user?.profile,
          email_id: selected_user?.email_id,
          mobile_number: selected_user?.mobile_number,
          _id: selected_user._id,
        };
      }
    }
    setSelectedUser(obj)
    setDropdownV1Value({[name] : value})
  }

  return (
    <Modal
      size="md"
      className=""
      scrollable
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      // style={{
      //   padding: "4rem",
      //   width: "45vw",
      //   marginLeft: "30vw",
      // }}
    >
      <Modal.Header closeButton className="modal_headers mt-2 mx-2 pb-0 ">
        <Modal.Title className="req_change_title fs-20px fw-bold text-theme">Request change</Modal.Title>
      </Modal.Header>
      <Modal.Body className="mx-1">
        <div className="multi_ddTConatiner px-1">
          <DashBoardMultiDropdown
            displayValue="label"
            onChange={(e) => {
              if (e)
              setDropDownValues([...e]);
            }}
            options={options}
            label={"Change"}
            value={dropDownValues}
          />
        </div>
        <Row className="row_comments_heading mx-0 mt-4">
          <div
            // style={{
            //   fontSize: "13px",
            //   padding: "0px 0px 0px 3px",
            // }}
            className="comments_head mb-1 commentsTextRequestchangeStyle"
          >
            Comments(optional)
          </div>
          <input
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            type="text"
            className="w-100 border border-1 border-black h-35px"
          />
        </Row>
        {assignee_required && assignee_required == 'true' ? <Row className="row_comments_heading mx-0 mt-4">
          <DropdownV1 
              options_type = {"all_users"}
              label = {"Assignee"}
              onChange = {dropdownv1OnChange}
              name = {"user_assignee"}
              value = {dropdownV1Value}
              selectedData = {dropdownV1Value}  
              isEditable ={true}
              request_change_option ={request_change_option}
              role = {role}
              user = {user}
              notification = {notification}
              size={'px-0'}
              workFlowCreatedBy={workFlowCreatedBy}
           />
        </Row> :''}
        <Row className="d-flex buttons_conatiner mt-2">
          <Col lg={6} xs={6} onClick={onHide} className="backButton">
            Back
          </Col>
          <Col lg={6} xs={6} className="send_button">
            {" "}
            <ButtonV1
              label="Send"
              className="primary_button"
              disabled={!(dropDownValues?.length != 0 && (assignee_required == 'true' ? dropdownV1Value.hasOwnProperty('user_assignee')? dropdownV1Value['user_assignee'].length != 0 : false : true))}
              onClick={handleSend}
            />
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default RequestChangeModal;
